export default __webpack_public_path__ + "static/media/playFlow_mobile.486559a3.svg";